import Button from '@/components/base/Button';
import Reveal from '@/components/base/Reveal';
import PageHero from '@/components/feature/PageHero';
import ChecklistPromo from '@/components/feature/ChecklistPromo';
import { SERVICES } from '@/data/site';

export default function Services() {
  return (
    <>
      <PageHero
        eyebrow="Our Services"
        title="Personal connections for exceptional events."
        intro="From finding one trusted specialist to sourcing several suppliers for a memorable occasion, KOR38 offers a personal approach tailored to what you need."
        imageSrc="https://storage.helloreaddy.io/project_files/70bd3036-f013-4766-9098-d293cc2afad4/09a75ddc-7aaf-4cf1-9b51-a14673d7c43f_compressed_Bridal-Beauty-Preparation-Suite-v2.webp"
        imageAlt="Bridal beauty preparation with hair and make-up styling in an elegant suite"
      />

      <section id="offers" className="w-full px-4 md:px-8 lg:px-12 pb-16 md:pb-28 bg-background-50">
        <div className="max-w-content mx-auto space-y-6">
          {SERVICES.map((service, index) => (
            <div key={service.id} id={service.id} className="scroll-mt-28 md:scroll-mt-32">
            <Reveal
              as="article"
              delay={index * 80}
              className="rounded-lg border border-background-200 bg-background-100 p-6 md:p-10"
            >
              <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
                <div className="lg:col-span-7">
                  <div className="flex items-center gap-4">
                    <span className="w-12 h-12 rounded-md bg-secondary-900 flex items-center justify-center">
                      <i className={`${service.icon} text-2xl text-primary-400`} aria-hidden="true"></i>
                    </span>
                    <span className="font-label text-xs uppercase tracking-[0.14em] text-accent-600">
                      {service.subheading}
                    </span>
                  </div>
                  <h2 className="mt-6 font-heading text-2xl md:text-3xl text-foreground-950">
                    {service.name}
                  </h2>
                  <p className="mt-4 text-base leading-relaxed text-foreground-700">
                    {service.summary}
                  </p>
                </div>

                <div className="lg:col-span-5 lg:pl-8 lg:border-l border-background-200 flex flex-col justify-between">
                  <div className="space-y-5">
                    <div>
                      <p className="font-label text-sm uppercase tracking-[0.14em] text-foreground-600">
                        Service Fee
                      </p>
                      <p className="mt-1 font-heading text-3xl md:text-4xl text-primary-300">
                        {service.price}
                      </p>
                      <p className="mt-1 text-[15px] text-foreground-600">{service.priceNote}</p>
                    </div>
                    <p className="text-[15px] leading-relaxed text-foreground-600 border-t border-background-200 pt-5">
                      {service.note}
                    </p>
                  </div>
                  <div className="mt-7">
                    <Button to={service.path} variant="primary" size="lg" className="w-full">
                      {service.cta}
                    </Button>
                  </div>
                </div>
              </div>
            </Reveal>
            </div>
          ))}

          <Reveal className="rounded-lg border border-background-200 bg-background-100 p-6 md:p-8">
            <p className="text-base leading-relaxed text-foreground-700">
              <strong className="font-semibold text-foreground-950">How we work:</strong> KOR38
              provides sourcing and introductions. Customers arrange contracts, bookings and payments
              directly with suppliers. KOR38 may receive disclosed referral commissions from
              suppliers. We currently serve Greater London; other areas are considered case by case.
            </p>
          </Reveal>

          <ChecklistPromo variant="services" />
        </div>
      </section>
    </>
  );
}